import gql from 'graphql-tag';

export const READ_THREAD_MESSAGES_MUTATION = gql`
  fragment MessagesReadThreadMessagesSuccess on UpdateMessageThreadMessagesSuccess {
    value
  }

  fragment MessagesReadThreadMessagesError on GenericError {
    kind
    message
  }

  mutation MessagesReadThreadMessages($threadId: ID!) {
    isUpdated: updateMessageThreadMessages(
      threadId: $threadId
      payload: { status: READ }
    ) {
      ...MessagesReadThreadMessagesSuccess
      ...MessagesReadThreadMessagesError
    }
  }
`;
